export const services = [
  {
    id: 1,
    name: 'Corte Masculino',
    description: 'Corte personalizado com técnicas clássicas e modernas. Análise do formato do rosto, textura e estilo pessoal para um resultado impecável.',
    duration: '45 min',
    price: 'R$ 75',
    image: 'https://storage.helloreaddy.io/project_files/1fff4f2a-b372-4b40-8698-6f714b3b8587/2f4f7cef-cd8f-4c97-9845-3610e71e9c61_compressed_Captura-de-tela-2026-07-30-183546.webp',
    icon: 'ri-scissors-cut-line',
  },
  {
    id: 2,
    name: 'Barba Completa',
    description: 'Aparação e modelagem com navalha, toalha quente, balm hidratante e acabamento premium. O ritual completo para uma barba impecável.',
    duration: '30 min',
    price: 'R$ 55',
    image: 'https://storage.helloreaddy.io/project_files/1fff4f2a-b372-4b40-8698-6f714b3b8587/e42eaebe-c756-4ce1-be49-a3f9f2c76947_compressed_Captura-de-tela-2026-07-30-183611.webp',
    icon: 'ri-user-smile-line',
  },
  {
    id: 3,
    name: 'Corte + Barba',
    description: 'Nosso combo premium. Corte personalizado e barba completa em uma experiência integrada. O favorito dos nossos clientes.',
    duration: '60 min',
    price: 'R$ 110',
    image: 'https://storage.helloreaddy.io/project_files/1fff4f2a-b372-4b40-8698-6f714b3b8587/51494a92-ae31-4902-a6d0-cc1188870ece_compressed_Captura-de-tela-2026-07-30-183810.webp',
    icon: 'ri-star-line',
  },
  {
    id: 4,
    name: 'Pigmentação Capilar',
    description: 'Técnica avançada de micropigmentação para disfarçar falhas, criar densidade e redefinir o contorno capilar com naturalidade.',
    duration: '90 min',
    price: 'R$ 200',
    image: 'https://readdy.ai/api/search-image?query=Premium%20barbershop%20scalp%20micropigmentation%20procedure%2C%20dark%20professional%20setting%2C%20precise%20technical%20work%2C%20masculine%20atmosphere%2C%20specialized%20equipment%2C%20warm%20lighting%2C%20clinical%20precision%20aesthetic%2C%20editorial%20black%20and%20white%20style&width=600&height=400&seq=service-pigment-04&orientation=landscape',
    icon: 'ri-contrast-drop-line',
  },
  {
    id: 5,
    name: 'Acabamento Premium',
    description: 'Finalização com produtos importados, massagem capilar, toalha quente e styling. O toque final que eleva qualquer corte.',
    duration: '20 min',
    price: 'R$ 45',
    image: 'https://readdy.ai/api/search-image?query=Premium%20barbershop%20hair%20finishing%20and%20styling%2C%20barber%20applying%20product%20with%20precision%2C%20dark%20moody%20lighting%2C%20masculine%20luxury%2C%20premium%20hair%20products%20on%20display%2C%20warm%20atmosphere%2C%20editorial%20photography%2C%20gold%20and%20charcoal%20tones&width=600&height=400&seq=service-acabamento-05&orientation=landscape',
    icon: 'ri-magic-line',
  },
  {
    id: 6,
    name: 'Sobrancelha Masculina',
    description: 'Design e alinhamento com navalha e pinça, respeitando a naturalidade. Para um olhar marcante sem perder a masculinidade.',
    duration: '15 min',
    price: 'R$ 30',
    image: 'https://readdy.ai/api/search-image?query=Premium%20barbershop%20eyebrow%20grooming%20for%20men%2C%20precise%20tweezing%20with%20professional%20care%2C%20dark%20masculine%20setting%2C%20close%20up%20detail%20work%2C%20warm%20lighting%2C%20clean%20aesthetic%2C%20editorial%20photography%2C%20charcoal%20and%20amber%20tones&width=600&height=400&seq=service-sobrancelha-06&orientation=landscape',
    icon: 'ri-eye-line',
  },
  {
    id: 7,
    name: 'Tratamentos Capilares',
    description: 'Hidratação profunda, reconstrução capilar e tratamentos antiqueda com tecnologia e produtos profissionais de alto desempenho.',
    duration: '40 min',
    price: 'R$ 90',
    image: 'https://readdy.ai/api/search-image?query=Premium%20barbershop%20hair%20treatment%20session%2C%20professional%20products%20application%2C%20dark%20masculine%20interior%2C%20barber%20applying%20treatment%20with%20precision%2C%20warm%20ambient%20light%2C%20luxury%20barbershop%20atmosphere%2C%20editorial%20photography&width=600&height=400&seq=service-tratamento-07&orientation=landscape',
    icon: 'ri-flask-line',
  },
];